<template>
    <QrButton
        v-if="useStripe"
        :text="trans('order.go_to_checkout')"
        trans="order.go_to_checkout"
        icon-right="cart-shopping-fast"
        icon-type="light"
        positive
        :loading="loading"
        @click="order(qrCode)"
    />
    <QrButton
        v-else
        :to="`/qr-codes/${qrCode.id}/order`"
        :text="trans('order.go_to_checkout')"
        trans="order.go_to_checkout"
        icon-right="cart-shopping-fast"
        icon-type="light"
        positive
    />
</template>

<script setup>
import { computed, ref } from "vue";
import { trans } from "@/libs/helper.js";
import { useUserStore } from "@/store/user.js";
import { storeToRefs } from "pinia";
import Storage from "@/libs/storage.js";
import QrButton from "@/components/application-ui/elements/QrButton.vue";

const userStore = useUserStore();
const { user } = storeToRefs(userStore);

const props = defineProps({
    qrCode: Object
});

const quantity = ref(1);
const additionalItems = ref([]);
const loading = ref(false)
const storage = new Storage();

const useStripe = computed(() => {
    return !user.value.agency;
});

const order = async (qrCode) => {
    const url = new URL(window.location.href);
    url.search = '';

    loading.value = true;
    const redirect = await axios.post(`/api/store/checkout/${qrCode.id}`, {
        'return_url': url.toString(),
        'quantity': quantity.value,
        'additional_items': additionalItems.value,
        'referral_code': storage.get('ref'),
    });
    loading.value = false;
    window.location.href = redirect.data.payment_url;
};

</script>
